/* ==========================================================================
   Moonou USP Tabs — Expandable accordion with smooth height animation
   Uses event delegation for robust click handling
   ========================================================================== */
(function () {
  'use strict';

  // Guard: prevent duplicate click handlers when multiple section instances load this script
  if (window.__moonouUtInit) return;
  window.__moonouUtInit = true;

  function openItem(item, animate) {
    var content = item.querySelector('.moonou-ut__content');
    var inner = item.querySelector('.moonou-ut__inner');
    var header = item.querySelector('.moonou-ut__header');
    if (!content || !inner) return;

    item.classList.add('is-open');
    if (header) header.setAttribute('aria-expanded', 'true');

    var targetHeight = inner.scrollHeight;

    if (animate === false) {
      content.style.maxHeight = targetHeight + 'px';
      return;
    }

    content.style.maxHeight = '0px';
    content.offsetHeight;
    content.style.maxHeight = targetHeight + 'px';
  }

  function closeItem(item) {
    var content = item.querySelector('.moonou-ut__content');
    var header = item.querySelector('.moonou-ut__header');
    if (!content) return;

    var currentHeight = content.scrollHeight;
    content.style.maxHeight = currentHeight + 'px';
    content.offsetHeight;
    content.style.maxHeight = '0px';

    item.classList.remove('is-open');
    if (header) header.setAttribute('aria-expanded', 'false');
  }

  /* ---- Event delegation: single click handler on document ---- */
  document.addEventListener('click', function (e) {
    var header = e.target.closest('.moonou-ut__header');
    if (!header) return;

    var item = header.closest('.moonou-ut__item');
    if (!item) return;

    var container = item.closest('.moonou-ut');
    if (!container) return;

    var isOpen = item.classList.contains('is-open');
    var isAccordion = container.hasAttribute('data-accordion');

    if (isAccordion && !isOpen) {
      container.querySelectorAll('.moonou-ut__item').forEach(function (otherItem) {
        if (otherItem !== item && otherItem.classList.contains('is-open')) {
          closeItem(otherItem);
        }
      });
    }

    if (isOpen) {
      closeItem(item);
    } else {
      openItem(item);
    }
  });

  /* ---- Initial open state + ResizeObserver ---- */
  function initSection(sectionEl) {
    var container = sectionEl.querySelector('.moonou-ut');
    if (!container) return;

    var initialOpen = container.getAttribute('data-initial-open');
    if (initialOpen === 'first') {
      var firstItem = container.querySelector('.moonou-ut__item');
      if (firstItem && !firstItem.classList.contains('is-open')) {
        openItem(firstItem, false);
      }
    }

    if (typeof ResizeObserver !== 'undefined') {
      if (sectionEl._moonouUtRo) sectionEl._moonouUtRo.disconnect();

      var ro = new ResizeObserver(function () {
        container.querySelectorAll('.moonou-ut__item.is-open').forEach(function (item) {
          var content = item.querySelector('.moonou-ut__content');
          var inner = item.querySelector('.moonou-ut__inner');
          if (content && inner) {
            content.style.maxHeight = inner.scrollHeight + 'px';
          }
        });
      });
      ro.observe(container);
      sectionEl._moonouUtRo = ro;
    }
  }

  function cleanupSection(sectionEl) {
    if (sectionEl._moonouUtRo) {
      sectionEl._moonouUtRo.disconnect();
      sectionEl._moonouUtRo = null;
    }
  }

  function initAll() {
    document.querySelectorAll('.moonou-usp-tabs-section').forEach(function (sectionEl) {
      cleanupSection(sectionEl);
      initSection(sectionEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.moonou-ut')) {
      cleanupSection(e.target);
      initSection(e.target);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    cleanupSection(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest('.moonou-ut__item');
    if (item && !item.classList.contains('is-open')) {
      openItem(item);
    }
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var item = e.target.closest('.moonou-ut__item');
    if (!item) return;
    var container = item.closest('.moonou-ut');
    if (container && container.hasAttribute('data-accordion')) {
      closeItem(item);
    }
  });
})();
